import React from "react";
import Modal from 'react-bootstrap/Modal'
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import "react-light-accordion/demo/css/index.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SideMenu from "./SideMenu";
import Header from "./Header";

class QuizPage extends React.Component {
  constructor(props) {
    super(props);
    this.syllabusData = "";
    this.state = {
      quizName: "",
      quizDate: "",
      quizYear: "",
      course: "",
      subjectsCount: "",
      subjects: "",
      showQuiz: false,
      allQuizzes: [],
      showUrlModal: false,
      // for url
      mathsExist: false,
      physicsExist: false,
      chemistryExist: false,
      mathsTestPaperLink: '',
      physicsTestPaperLink: '',
      chemistryTestPaperLink: '',
      mathsVideoLink: '',
      physicsVideoLink: '',
      chemistryVideoLink: '',
      mathsPdfLink: '',
      physicsPdfLink: '',
      chemistryPdfLink: '',
      modalQuizName: '',
      modalQuizYear: '',
      modalQuizDescription: '',
      modalQuizId: '',
      // syllabus
      showSyllabusModal: false,
      syllabusQuizId: '',
      syllabusForModal: ''
    };
  }

  componentDidMount() {
    this.fetchAllQuizzes();
  }

  fetchAllQuizzes = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.data.accessToken
    };
    let url = `http://15.206.132.121:3002/api/getAllQuizzesDetails`;
    fetch(url, { headers })
      .then(response => response.json())
      .then(data => {
        if (!data.success) {
          throw data.message;
        }
        this.setState({ allQuizzes: data.data });
      })
      .catch(err => {
        toast.error("Error! Please try again", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      });
  };

  deleteQuiz = quizId => {
    let result = window.confirm("Are you sure you want to delete this quiz");
    if (result) {
      let user = JSON.parse(localStorage.getItem("user"));
      const requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.data.accessToken
        },
      };
      let url = `http://15.206.132.121:3002/api/deleteQuiz?quizId=${quizId}`;
      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (!data.success) {
            throw data.message
          }
          this.fetchAllQuizzes();
          toast.success("Quiz Deleted successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
        })
        .catch((err) => {
          toast.error("Either System error or Quiz mapped with Challenge or Result", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    }
  };

  submitQuizCreation = e => {
    e.preventDefault();

    // get our form data out of state
    const {
      quizName,
      quizDate,
      quizYear,
      course,
      subjectsCount,
      subjects
    } = this.state;
    let user = JSON.parse(localStorage.getItem("user"));
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.data.accessToken
      },
      body: JSON.stringify({
        quizName,
        quizDate,
        quizYear,
        course,
        subjectsCount,
        subjects
      })
    };
    let url = "http://15.206.132.121:3002/api/addQuiz";
    return fetch(url, requestOptions)
      .then(response => response.json())
      .then(res => {
        if (!res.success) {
          throw res.message;
        }
        this.fetchAllQuizzes();
        toast.success("Quiz created successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        this.setState({
          quizName: "",
          quizDate: "",
          quizYear: "",
          course: "",
          subjectsCount: "",
          subjects: ""
        });
      })
      .catch(err =>
        toast.error("Quiz Creation Failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        })
      );
  };

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  toggleQuiz = () => {
    this.setState({
      showQuiz: !this.state.showQuiz
    });
  };

  addUrls = (id) => {
    if (id) {
      let allQuizzes = this.state.allQuizzes;
      for (let i = 0; i < allQuizzes.length; i++) {
        if (allQuizzes[i].QuizID === id) {
          this.setState({
            modalQuizDescription: allQuizzes[i].Description,
            modalQuizYear: allQuizzes[i].QuizYear,
            modalQuizName: allQuizzes[i].QuizName,
            modalQuizId: allQuizzes[i].QuizID
          })
        }
      }
    }
    this.fetchUrlData(id);
    this.setState({
      showUrlModal: !this.state.showUrlModal
    })
  }

  fetchUrlData = (id) => {
    let user = JSON.parse(localStorage.getItem("user"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.data.accessToken
    };
    let url = `http://15.206.132.121:3002/api/getQuizSubjectsInfoLinks?quizId=${id}`;
    fetch(url, { headers })
      .then(response => response.json())
      .then(data => {
        if (!data.success) {
          throw data.message;
        }
        this.setUrlData(data.data)
      })
      .catch(err => {
        toast.error("Error! Please try again", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      });
  }

  setUrlData = (urlData) => {
    for (let i = 0; i < urlData.length; i++) {
      if (urlData[i].SubjectName.toLocaleLowerCase() === 'maths') {
        this.setState({
          mathsExist: true,
          mathsTestPaperLink: urlData[i].TestPaperLinks,
          mathsPdfLink: urlData[i].PdfSolutionLinks,
          mathsVideoLink: urlData[i].VideoSolutionLinks
        })
      }
      if (urlData[i].SubjectName.toLocaleLowerCase() === 'physics') {
        this.setState({
          physicsExist: true,
          physicsTestPaperLink: urlData[i].TestPaperLinks,
          physicsPdfLink: urlData[i].PdfSolutionLinks,
          physicsVideoLink: urlData[i].VideoSolutionLinks
        })
      }
      if (urlData[i].SubjectName.toLocaleLowerCase() === 'chemistry') {
        this.setState({
          chemistryExist: true,
          chemistryTestPaperLink: urlData[i].TestPaperLinks,
          chemistryPdfLink: urlData[i].PdfSolutionLinks,
          chemistryVideoLink: urlData[i].VideoSolutionLinks
        })
      }
    }

  }

  onChangeUrl = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  submitUrls = async (e) => {
    e.preventDefault();
    let user = JSON.parse(localStorage.getItem("user"));
    let maths = "maths";
    let chemistry = "chemistry";
    let physics = "physics"
    let urlMaths = `http://15.206.132.121:3002/api/addInfolinksToQuizSubjects?quizId=${this.state.modalQuizId}&subjectName=${maths}`
    let urlChemistry = `http://15.206.132.121:3002/api/addInfolinksToQuizSubjects?quizId=${this.state.modalQuizId}&subjectName=${chemistry}`
    let urlPhysics = `http://15.206.132.121:3002/api/addInfolinksToQuizSubjects?quizId=${this.state.modalQuizId}&subjectName=${physics}`
    const bodyMaths = JSON.stringify({
      description: this.state.modalQuizDescription,
      testPaperLinks: this.state.mathsTestPaperLink,
      videoSolutionLinks: this.state.mathsVideoLink,
      pdfSolutionLinks: this.state.mathsPdfLink
    })
    const bodyPhysics = JSON.stringify({
      description: this.state.modalQuizDescription,
      testPaperLinks: this.state.physicsTestPaperLink,
      videoSolutionLinks: this.state.physicsVideoLink,
      pdfSolutionLinks: this.state.physicsPdfLink
    })
    const bodyChemistry = JSON.stringify({
      description: this.state.modalQuizDescription,
      testPaperLinks: this.state.chemistryTestPaperLink,
      videoSolutionLinks: this.state.chemistryVideoLink,
      pdfSolutionLinks: this.state.chemistryPdfLink
    })
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.data.accessToken
      }
    };
    try {
      requestOptions.body = bodyMaths;
      let resMaths = await fetch(urlMaths, requestOptions);
      let dataMaths = await resMaths.json();
      requestOptions.body = bodyPhysics;
      let resPhysics = await fetch(urlPhysics, requestOptions);
      let dataPhysics = await resPhysics.json();
      requestOptions.body = bodyChemistry;
      let resChemistry = await fetch(urlChemistry, requestOptions);
      let dataChemistry = await resChemistry.json();
      if (!dataMaths.success || !dataChemistry.success || !dataPhysics.success) {
        throw "error";
      }
      this.closeModal();
      this.fetchAllQuizzes();
      toast.success("Url updated successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
    catch (err) {
      toast.error("Url Updation Failed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      })
    }
  }

  showSyllabusModal = (id) => {
    let syllabus = ''
    for (let i = 0; i < this.state.allQuizzes.length; i++) {
      if (this.state.allQuizzes[i].QuizID === id) {
        syllabus = this.state.allQuizzes[i].Syllabus
      }
    }
    this.setState({
      showSyllabusModal: true,
      syllabusQuizId: id,
      syllabusForModal: syllabus
    })
  }

  closeModal = () => {
    this.setState({
      showUrlModal: false,
      mathsTestPaperLink: '',
      physicsTestPaperLink: '',
      chemistryTestPaperLink: '',
      mathsVideoLink: '',
      physicsVideoLink: '',
      chemistryVideoLink: '',
      mathsPdfLink: '',
      physicsPdfLink: '',
      chemistryPdfLink: '',
      modalQuizName: '',
      modalQuizYear: '',
      modalQuizDescription: '',
      modalQuizId: '',
    })
  }
  closeSyllabusModal = () => {
    this.setState({
      showSyllabusModal: false
    })
  }

  submitSyllabus = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.data.accessToken
      },
      body: JSON.stringify({
        syllabus: this.syllabusData
      })
    };
    let url = `http://15.206.132.121:3002/api/updateQuizSyllabus?quizId=${this.state.syllabusQuizId}`;
    return fetch(url, requestOptions)
      .then(response => response.json())
      .then(res => {
        if (!res.success) {
          throw res.message;
        }
        this.closeSyllabusModal();
        this.fetchAllQuizzes();
        toast.success("Syllabus added successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });

      })
      .catch(err =>
        toast.error("Syllabus Addition Failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        })
      );
  }
  render() {
    let user = JSON.parse(localStorage.getItem("user"));
    const {
      quizName,
      quizDate,
      quizYear,
      course,
      subjectsCount,
      subjects,
      showUrlModal,
      chemistryPdfLink,
      chemistryTestPaperLink,
      chemistryVideoLink,
      mathsTestPaperLink,
      mathsPdfLink,
      mathsVideoLink,
      physicsPdfLink,
      physicsTestPaperLink,
      physicsVideoLink,
      modalQuizDescription,
      modalQuizName,
      modalQuizYear,
      showSyllabusModal,
      syllabusForModal
    } = this.state;
    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Modal
          show={showSyllabusModal}
          size="lg"
          onHide={() => this.closeSyllabusModal()}
          style={{ opacity: "1", marginTop: "1%" }}
          backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton style={{ marginTop: '14%' }}>
            <Modal.Title id="example-modal-sizes-title-lg">
              Add Syllabus
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ minHeight: "200px" }}>
            <CKEditor
              editor={ClassicEditor}
              data={syllabusForModal}
              onInit={editor => {
                // You can store the "editor" and use when it is needed.
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                this.syllabusData = data;
              }}
              onBlur={(event, editor) => {
              }}
              onFocus={(event, editor) => {
              }}
            />
            <button
              className="btn btn-primary" onClick={this.submitSyllabus} style={{ marginTop: "15px" }}
            >
              Submit
                            </button>

          </Modal.Body>
        </Modal>
        <Modal
          show={showUrlModal}
          size="lg"
          onHide={() => this.closeModal()}
          style={{ opacity: "1", marginTop: "1%" }}
          backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton style={{ marginTop: '24%' }}>
            <Modal.Title id="example-modal-sizes-title-lg">
              Add Urls
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form

              onSubmit={this.submitUrls}
            >
              <div className="contact" style={{ height: "800px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className="contact-form"
                      style={{
                        padding: "4%"
                      }}
                    >
                      <div className="form-group">
                        <label
                          className="control-label col-sm-3 fontClass"
                          htmlFor="name"
                        >
                          Quiz Name
                        </label>
                        <div className="col-sm-9">
                          {modalQuizName}
                        </div>
                      </div>
                      <div className="form-group">
                        <label
                          className="control-label col-sm-3 fontClass "
                          htmlFor="name"
                        >
                          Quiz Year:
                        </label>
                        <div className="col-sm-9">
                          {modalQuizYear}
                        </div>
                      </div>

                      <div className="form-group">
                        <label
                          className="control-label col-sm-3 fontClass"
                          htmlFor="modalQuizDescription"
                        >
                          Description
                                                            </label>
                        <div className="col-sm-9">
                          <textarea
                            name="modalQuizDescription"
                            value={modalQuizDescription}
                            onChange={this.onChangeUrl}
                            className="form-control"
                            placeholder="Enter description"

                          />
                        </div>
                      </div>
                      {this.state.mathsExist &&
                        <div>
                          <h3>Maths</h3>
                          <div className="form-group">
                            <label
                              className="control-label col-sm-3 fontClass"
                              htmlFor="mathsTestPaperLink"
                            >
                              Test Paper Link
                                                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="mathsTestPaperLink"
                                value={mathsTestPaperLink}
                                onChange={this.onChangeUrl}
                                className="form-control"
                                placeholder="Enter url"

                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label
                              className="control-label col-sm-3 fontClass"
                              htmlFor="mathsVideoLink"
                            >
                              Video Solutions Link
                                                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="mathsVideoLink"
                                value={mathsVideoLink}
                                onChange={this.onChangeUrl}
                                className="form-control"
                                placeholder="Enter url"

                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label
                              className="control-label col-sm-3 fontClass"
                              htmlFor="mathsPdfLink"
                            >
                              PDF Solutions Link
                                                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="mathsPdfLink"
                                value={mathsPdfLink}
                                onChange={this.onChangeUrl}
                                className="form-control"
                                placeholder="Enter url"

                              />
                            </div>
                          </div> </div>}
                      {this.state.physicsExist && <div>
                        <h3>Physics</h3>
                        <div className="form-group">

                          <label
                            className="control-label col-sm-3 fontClass"
                            htmlFor="physicsTestPaperLink"
                          >
                            Test Paper Link
                                                            </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="physicsTestPaperLink"
                              value={physicsTestPaperLink}
                              onChange={this.onChangeUrl}
                              className="form-control"
                              placeholder="Enter url"

                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3 fontClass"
                            htmlFor="physicsVideoLink"
                          >
                            Video Solutions Link
                                                            </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="physicsVideoLink"
                              value={physicsVideoLink}
                              onChange={this.onChangeUrl}
                              className="form-control"
                              placeholder="Enter url"

                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3 fontClass"
                            htmlFor="physicsPdfLink"
                          >
                            PDF Solutions Link
                                                            </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="physicsPdfLink"
                              value={physicsPdfLink}
                              onChange={this.onChangeUrl}
                              className="form-control"
                              placeholder="Enter url"

                            />
                          </div>
                        </div></div>}
                      {this.state.chemistryExist && <div>
                        <h3>Chemistry</h3>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3 fontClass"
                            htmlFor="chemistryTestPaperLink"
                          >
                            Test Paper Link
                                                            </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="chemistryTestPaperLink"
                              value={chemistryTestPaperLink}
                              onChange={this.onChangeUrl}
                              className="form-control"
                              placeholder="Enter url"

                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3 fontClass"
                            htmlFor="chemistryVideoLink"
                          >
                            Video Solutions Link
                                                            </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="chemistryVideoLink"
                              value={chemistryVideoLink}
                              onChange={this.onChangeUrl}
                              className="form-control"
                              placeholder="Enter url"

                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3 fontClass"
                            htmlFor="chemistryPdfLink"
                          >
                            PDF Solutions Link
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="chemistryPdfLink"
                              value={chemistryPdfLink}
                              onChange={this.onChangeUrl}
                              className="form-control"
                              placeholder="Enter url"

                            />
                          </div>
                        </div>
                      </div>}

                      <div className="form-group">
                        <div className="col-sm-12">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ float: "right" }}
                          >
                            Submit
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form></Modal.Body>
        </Modal>
        <section id="container">
          <Header />
          <SideMenu />
          <section id="main-content">
            <section className="wrapper">
              <div>
                <button
                  className="btn btn-primary mt-5"
                  onClick={this.toggleQuiz}
                >
                  {this.state.showQuiz ? "Show Quizzes" : "Add Quiz"}
                </button>
              </div>
              <form
                className={this.state.showQuiz ? "collapse in" : "collapse"}
                onSubmit={this.submitQuizCreation}
              >
                <div className="contact">
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="contact-form"
                        style={{
                          padding: "4%"
                        }}
                      >
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3"
                            htmlFor="quizName"
                          >
                            Quiz Name:
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="quizName"
                              value={quizName}
                              onChange={this.onChange}
                              className="form-control"
                              placeholder="Enter Quiz Name"
                              required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3"
                            htmlFor="quizDate"
                          >
                            Quiz Date
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="date"
                              className="form-control"
                              name="quizDate"
                              value={quizDate}
                              onChange={this.onChange}
                              placeholder="Enter Quiz Date"
                              required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3"
                            htmlFor="quizYear"
                          >
                            Quiz Year
                          </label>
                          <div className="col-sm-9">
                            <input
                              className="form-control"
                              type="number"
                              name="quizYear"
                              value={quizYear}
                              onChange={this.onChange}
                              placeholder="Enter Quiz Year"
                              required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3"
                            htmlFor="comment"
                          >
                            Course name:
                          </label>
                          <div className="col-sm-9">
                            <input
                              className="form-control"
                              type="text"
                              name="course"
                              value={course}
                              onChange={this.onChange}
                              placeholder="Enter Course Name"
                              required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3"
                            htmlFor="comment"
                          >
                            Number of subjects:
                          </label>
                          <div className="col-sm-9">
                            <input
                              className="form-control"
                              type="number"
                              name="subjectsCount"
                              value={subjectsCount}
                              onChange={this.onChange}
                              placeholder="Enter Number of Subjects"
                              required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label col-sm-3"
                            htmlFor="comment"
                          >
                            Name of subjects (comma separated):
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="subjects"
                              value={subjects}
                              onChange={this.onChange}
                              placeholder="Enter Name of Subjects"
                              required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="col-sm-12">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              style={{ float: "right" }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div className="scroll-fit">
                <table className="table table-hover general-table">
                  <thead>
                    <tr>
                      <th> S.No</th>
                      <th>Quiz Name</th>
                      <th>Quiz Date</th>
                      <th>Quiz Year</th>
                      <th>Course name</th>
                      <th>Subjects</th>
                      <th>Challenge</th>
                      <th>Result Uploaded</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.allQuizzes.map((quiz, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{quiz.QuizName}</td>
                          <td>{quiz.QuizDate}</td>
                          <td>{quiz.QuizYear}</td>
                          <td>{quiz.Course}</td>
                          <td>{quiz.SubjectNames}</td>
                          <td>{quiz.ChallengeName}</td>
                          <td>{quiz.IsResultUploaded}</td>
                          <td>
                            <button
                              className="btn btn-primary" style={{ marginTop: "5px", marginRight: "4px" }}
                              onClick={() => this.deleteQuiz(quiz.QuizID)}
                            >
                              Delete
                            </button>

                            <button
                              className="btn btn-primary" style={{ marginTop: "5px", marginRight: "4px" }}
                              onClick={() => this.addUrls(quiz.QuizID)}
                            >
                              Add Url
                            </button>
                            <button
                              className="btn btn-primary" style={{ marginTop: "5px" }}
                              onClick={() => this.showSyllabusModal(quiz.QuizID)}
                            >
                              Add Syllabus
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>
          </section>
        </section>
      </div>
    );
  }
}

export default QuizPage;
